import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Section from '../../../enums/Sections';
import RenderOn from '../../../UI/RenderOn/RenderOn';
import Translation from '../../lang/Translation';
import useStyles from './ProgressBar.styles';
import ProgressBarCounter from './ProgressBarCounter/ProgressBarCounter';
import ProgressBarRow from './ProgressBarRow/ProgressBarRow';
import ProgressBarStep from './ProgressBarStep/ProgressBarStep';

const names = {
  [Section.ADDRESS]: 'address',
  [Section.DELIVERY]: 'deliveryOptions',
  [Section.PAYMENT]: 'paymentOptions',
};

export function ProgressBar(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <RenderOn mobile>
      <div
        className={classes.progressBar}
        data-test="ProgressBar"
        aria-label={Translation.getText('checkout.progress.bar')}
      >
        <ProgressBarRow>
          {props.sections.map((section, index) => (
            <ProgressBarStep
              number={index + 1}
              name={names[section]}
              label={section.toLowerCase()}
            />
          ))}
        </ProgressBarRow>
        <ProgressBarRow>
          {props.sections.map((section, index) => <ProgressBarCounter number={index + 1} />)}
          <div className={classes.progressLine} data-test="ProgressBar__line" />
        </ProgressBarRow>
      </div>
    </RenderOn>
  );
}

ProgressBar.propTypes = {
  checkoutProgressStep: PropTypes.number.isRequired,
  sections: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapStepStateToProps = state => ({
  checkoutProgressStep: state.ui.checkoutProgressStep,
  sections: state.ui.sections,
});

export default connect(mapStepStateToProps)(ProgressBar);
